<hc-modal>
    <hc-modal-header>
        <span class="icon-left icon-warn"></span>
        Session Timeout Warning
    </hc-modal-header>
    <hc-modal-body class="modal-body">
        <div>Your session is about to expire. You will be signed out in:</div>
        <div class="modal-counter">{{ countdownDisplay | number: '1.0-0' }} seconds</div>
    </hc-modal-body>
    <hc-modal-footer>
        <button hc-button buttonStyle="secondary" (click)="onSignOut()">
            <span class="icon-left icon-sign-out"></span>
            Sign out
        </button>
        <button hc-button buttonStyle="primary" (click)="onContinueSession()">Stay signed in</button>
    </hc-modal-footer>
</hc-modal>
